var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-item"},[_c(_vm.itemComponent,{ref:"filterItem",tag:"component",attrs:{"data":_vm.newData,"value":_vm.value,"placeholder":_vm.placeholder},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }